module.exports = __webpack_public_path__ + "static/media/logo.fab638b2.svg";